import DOMPurify from 'dompurify';

interface ComputerVision {
  text?: string;
}

/**
 * Returns a sanitized HTML fragment with the computer vision extracted text.
 * Returns an empty string when computer_vision or its text field is absent.
 *
 * @param computerVision - The computer_vision field from the post
 * @param headerLabel    - Pre-translated header label (e.g. "Text extracted from image (via AI)")
 */
export function parseImageText(
  computerVision: ComputerVision | undefined | null,
  headerLabel: string,
): string {
  if (!computerVision?.text) return '';

  const purify = DOMPurify(globalThis);
  const sanitizedText = purify.sanitize(computerVision.text.replaceAll('\n', '<br>'), {
    ALLOWED_TAGS: ['br'],
  });

  return `<b>${headerLabel}</b> ${sanitizedText}`;
}
